import { Expose } from "class-transformer";

export class CreateWorkplaceTypeDto {
  @Expose()
  name: string;
}
